// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Balloon from '/react4xp/components/Balloon'
import Mask from '/react4xp/components/Mask'
import Image from '/react4xp/components/Image'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// prop types
interface ListContactCardsProps {
    bgColor: 'white' | 'yoghurt'
    mainTitle?: string
    section: Array<{
        sectionTitle?: string
        sectionPhoneText?: string
        sectionPhone?: string

        cards: Array<{
            src: string
            alt?: string
            name: string
            position?: string
            phone?: string
            email?: string
        }>
    }>
}

export default function ListContactCards({
    bgColor,
    mainTitle,
    section
}: ListContactCardsProps) {
    return (
        <Section
            bgColor={bgColor}
            className='list-contact-cards'
        >
            <div className='container'>

                {isNonWhitespaceString(mainTitle) && (
                    <Balloon
                        balloonColor={bgColor === 'white' ? 'yoghurt' : 'white'}
                        arrow='bottom-middle'
                        arrowSide='left'
                        arrowSize='small'
                        balloonSide='right'
                        spacing='small'
                        className='list-contact-cards__main-title'
                    >
                        <h2 className='h2'>
                            {mainTitle}
                        </h2>
                    </Balloon>
                )}

                <div className='list-contact-cards__sections'>
                    {section?.map((item, i) => (
                        <div className='section' key={i}>
                            
                            <div className='row'>
                                <div className='col-md-10 col-lg-8 col-xl-6'>

                                    {isNonWhitespaceString(item.sectionTitle) && (
                                        <h3 className='h3 section__title'>
                                            {item.sectionTitle}
                                        </h3>
                                    )}

                                    {isNonWhitespaceString(item.sectionPhone) && (
                                        <a href={`tel:${item.sectionPhone}`} className='regular-link section__phone'>
                                            {item.sectionPhoneText}: {item.sectionPhone}
                                        </a>
                                    )}

                                </div>
                            </div>

                            <div className='section__grid'>

                                {item.cards?.map((card, i) => (
                                    <div className='contact-card-item' key={i}>

                                        {card.src && (
                                            <Mask className='contact-card-item__image'>
                                                <Image
                                                    src={card.src}
                                                    alt={card.alt}
                                                    width={400} // 400x350
                                                    className='cover'
                                                />
                                            </Mask>
                                        )}

                                        <Mask
                                            bgColor={clsx(bgColor === 'white' ? 'yoghurt' : 'white')}
                                            className='contact-card-item__wrapper'
                                        >

                                            {isNonWhitespaceString(card.name) && (
                                                <h4 className='text-big contact-card-item__name'>
                                                    <strong>
                                                        {card.name}
                                                    </strong>
                                                </h4>
                                            )}

                                            {isNonWhitespaceString(card.position) && (
                                                <p className='text-small contact-card-item__position'>
                                                    <strong>
                                                        {card.position}
                                                    </strong>
                                                </p>
                                            )}

                                            <div className='contact-card-item__links text-small'>

                                                {isNonWhitespaceString(card.phone) && (
                                                    <a href={`tel:${card.phone}`} className='regular-link'>
                                                        {card.phone}
                                                    </a>
                                                )}

                                                {isNonWhitespaceString(card.email) && (
                                                    <a href={`mailto:${card.email}`} className='regular-link'>
                                                        {card.email}
                                                    </a>
                                                )}

                                            </div>

                                        </Mask>
                                        
                                    </div>
                                ))}

                            </div>

                        </div>
                    ))}
                </div>

            </div>
        </Section>
        
    )
}